export const headers = {
  initialHeaders: [
    {
      title: "Nombre del empleado",
      field: "employee",
      child: "fullName",
    },
    {
      title: "Número de documento",
      field: "employee",
      child: "document",
    },
    {
      title: "Fecha inicial",
      field: "workStartDate",
      child: "workStartDate",
    },
    {
      title: "Fecha final",
      field: "workEndDate",
      child: "workEndDate",
    },
    {
      title: "Tipo de contrato",
      field: "contractTypeFormat",
      child: "contractType",
    },
  ],
  otherHeaders: [
    {
      title: "Tipo de identificación",
      field: "employee",
      child: "documentType",
    },
    {
      title: "Regional",
      field: "regional",
      child: null,
    },
    {
      title: "Cargo",
      field: "cargo",
      child: null,
    },

    {
      title: "Estado",
      field: "status",
      child: null,
    },
  ],
};
export const fakeData = {
  content: [
    {
      id: "c967c439-4a99-496d-a7e8-f861b9f521a8",
      employeeName: "Alejandra Romero Sarmiento",
      documentNumber: "122545EF",
      documentType: "Cedula",
      initDate: "19/10/2021 21:55:32",
      endDate: "22/10/2021 21:55:32",
      contractType: "CONTRATO_DE_APRENDIZAJE",
      status: "Activo",
    },
    {
      id: "c967c439-4a99-496d-a7e8-f861b9f521a9",
      employeeName: "Alejandra Romero Sarmiento",
      documentNumber: "122545EF",
      documentType: "Cedula",
      initDate: "19/10/2021 21:55:32",
      endDate: "22/10/2021 21:55:32",
      contractType: "CONTRATO_DE_APRENDIZAJE",
      status: "Activo",
    },
    {
      id: "c967c439-4a99-496d-a7e8-f861b9f521a10",
      employeeName: "Alejandra Romero Sarmiento",
      documentNumber: "122545EF",
      documentType: "Cedula",
      initDate: "19/10/2021 21:55:32",
      endDate: "22/10/2021 21:55:32",
      contractType: "CONTRATO_DE_APRENDIZAJE",
      status: "Activo",
    },
  ],
  pageable: {
    sort: {
      sorted: true,
      unsorted: false,
      empty: false,
    },
    offset: 0,
    pageNumber: 0,
    pageSize: 10,
    paged: true,
    unpaged: false,
  },
  totalElements: 161,
  last: false,
  totalPages: 17,
  sort: {
    sorted: true,
    unsorted: false,
    empty: false,
  },
  size: 10,
  number: 0,
  numberOfElements: 10,
  first: true,
  empty: false,
};
